export default __webpack_public_path__ + "static/vogue_colors_1-638c046724d4b44dc7529ab41d1d8e12.png";